import {FIELD_TYPE} from "types/enums";

const {TEXT_AREA, RADIO_BUTTON} = FIELD_TYPE;

const css = {xs: 24, sm: 24, md: 24, lg: 24, xl: 24};
const wrapperCol = {xs: 3, md: 3, lg: 3};
const labelCol = {xs: 3, md: 3, lg: 3};

const fieldsExamTab: any[] = [
  {
    label: "Ghi chú",
    type: TEXT_AREA,
    placeholder: "Nhập",
    name: "Ghi chú",
    css: css,
    labelCol: labelCol,
    wrapperCol: {xs: 21, md: 21, lg: 21},
    rows: 2,
  },
  {
    label: "Khám tổng quát:",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: "Bình thường", label: "Bình thường"},
      {value: "Bất thường", label: "Bất thường"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: {xs: 6, md: 6, lg: 6},
    name: "Khám tổng quát",
    value: "Bình thường",
  },
  {
    label: "Mắt độc nhất :",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: "Mắt độc nhất",
    value: false,
  },
  {
    label: "Đánh giá lác :",
    type: RADIO_BUTTON,
    radioButtons: [
      {value: true, label: "Có"},
      {value: false, label: "Không"},
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: "Đánh giá lác",
    value: false,
  },
];

const normalAppearance = {"Ghi chú": "Bình thường"};
const normalAppendage = {"Ghi chú": "Bình thường"};
const normalConjuctiva = {"Ghi chú": "Bình thường"};
const normalSclera = {"Ghi chú": "Bình thường"};
const normalCornea = {
  "Kích thước": "Bình thường",
  "Hình dạng": "Bình thường",
  "Bề mặt": ["Bình thường"],
};
const normalAnterior = {"Độ sâu": "Bình thường"};
const normalPupil = {
  "Hình dạng": "Tròn",
  "Phản xạ ánh sáng trực tiếp": "Bình thường",
  "Phản xạ ánh sáng đồng thuận": "Bình thường",
};
const normalIris = {"Hình dạng": "Bình thường"};
const normalLens = {
  "Hình thái": "Trong",
  "Vị trí": "Trung tâm",
  "Kích thước": "Bình thường",
};
export {
  fieldsExamTab,
  normalAppearance,
  normalAppendage,
  normalConjuctiva,
  normalSclera,
  normalCornea,
  normalAnterior,
  normalPupil,
  normalIris,
  normalLens,
};
